@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackTestimonialPresentation {
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: relative;
  align-items: center;

  .whiteShadow {
    width: 239px;
    height: 124px;
    position: absolute;
    background: #ffffff58;
    filter: blur(100px);
    top: -77px;
    left: calc(50% - 120px)
  }

  .title {
    font-size: 54px;
    width: 100%;
    position: relative;
    z-index: 1;
    text-align: center;

    @include texts.font("bold");
  }

  .stats {
    background: #a2bfff17;
    border: 1px solid #ffffff2e;
    border-radius: 40px;
    width: calc(100% - 80px);
    padding: 40px;
    display: flex;
    margin-top: 30px;
    position: relative;

    .stat {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 100%;
      align-items: center;

      .value {
        font-size: 46px;
        width: 100%;
        text-align: center;
        color: var(--green);
        position: relative;
        z-index: 1;

        @include texts.font("bold");
      }

      .label {
        font-size: 17px;
        width: 100%;
        text-align: center;
        color: var(--white);
        position: relative;
        z-index: 1;
      }

      .shadow {
        background: var(--web-green);
        filter: blur(70px);
        pointer-events: none;
        width: 168px;
        height: 56px;
        bottom: 0;
        position: absolute;
      }
    }
  }

  .line {
    height: 25px;
    width: 100%;
  }

  .customer {
    display: flex;
    gap: 15px;
    width: 100%;
    margin-top: 12px;

    .texts {
      font-size: 15px;
      width: 50%;
      position: relative;
      z-index: 1;

      .name {
        font-size: 28px;
        margin-bottom: 15px;

        @include texts.font("semi-bold");
      }
    }

    .image {
      width: 50%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 22px;
      height: 280px;
    }
  }

  @media screen and (max-width: 930px) {
    .title {
      font-size: 32px;
      text-align: center;
      width: 100%;
    }

    .stats {
      display: block;

      .stat {
        margin-bottom: 25px;

        .value {
          font-size: 32px;
        }

        .shadow {
          display: none;
        }
      }
    }

    .customer {
      flex-direction: column;

      .texts {
        width: 100%;
      }

      .image {
        width: 100%;
      }
    }
  }
}